import { apiClient, endpoints, unwrap } from '@core/api';
import { useAuthStore } from '@core/store/authStore';
import { useStoreContextStore } from '@core/store/storeContextStore';

function authHeader() {
  const { accessToken, tokenType } = useAuthStore.getState();
  if (!accessToken) throw new Error('Not signed in');
  return { Authorization: `${tokenType || 'Bearer'} ${accessToken}` };
}

function asList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  const candidates = [
    payload.items,
    payload.favorite_items,
    payload.favoriteItems,
    payload.records,
    payload.results,
    payload.data,
    payload.list,
  ];
  return candidates.find(Array.isArray) ?? [];
}

export async function listFavoriteItems() {
  const { locationId } = useStoreContextStore.getState();
  const raw = await apiClient.get(endpoints.auth.favoriteItems, {
    headers: authHeader(),
    query: {
      location_id: locationId || undefined,
    },
  });
  const { data } = unwrap(raw);
  return asList(data ?? raw);
}

export async function updateFavoriteItem({ operation, itemId }) {
  const raw = await apiClient.post(endpoints.auth.favoriteItemsOperation(operation), {
    headers: authHeader(),
    data: { item_id: itemId },
  });
  return unwrap(raw).data ?? raw;
}
